// extracted by mini-css-extract-plugin
export default {"summary":"CryptosSummary_summary__sHafs"};